import styled from '../../../../utils/styling/styled';

export const Marker = styled.svg<{ variant: 'partner' | 'showroom' }>`
  width: 50px;
  z-index: ${props => (props.variant === 'partner' ? 1 : 2)};
`;
